import { BaseActions } from '@/models/Common/Actions/BaseActions';
import { execAction } from '@/models/Common/Actions/handler';
import debug from 'debug';
import { ICertGetCIRequestParams } from './interfaces/ICertGetCIRequestParams';
import { ICertGetCIPayload } from './interfaces/ICertGetCIPayload';
import { CertRequestBuilder } from './CertRequestBuilder';
import { ResponseEither } from '@/models/Common/ResponseEither';

const log = debug('sunny:CertActions');

export class CertActions extends BaseActions<CertRequestBuilder> {
  getCI(params?: ICertGetCIRequestParams): Promise<ResponseEither<ICertGetCIPayload>> {
    log('get ci certification');
    return execAction('cert get ci', this.requestBuilder.createGetCI(params));
  }
}
